'use strict';
import template from './mx-grid-settings-panel.component.html';

export default {
	bindings: {
		grid: '<',

		rowColoringEnabled: '=?',
		availableRowHeights: '<',
		rowHeight: '=?',
	},
	controller: () => {},
	controllerAs: 'vm',
	template: template,
};
